import { Sparkle } from "lucide-react";
import { MARQUEE_WORDS } from "@/data/site";
import { useText } from "@/context/ContentContext";

// Marquee words are edited as one comma-separated list (Admin > Website Text).
export function Marquee() {
  const raw = useText("marquee.words", MARQUEE_WORDS.join(", "));
  const list = raw.split(",").map((w) => w.trim()).filter(Boolean);
  const words = [...list, ...list];
  return (
    <section className="bg-cream border-y border-ink/10 py-7 sm:py-10 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center">
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className={`px-6 sm:px-10 text-5xl sm:text-7xl lg:text-8xl tracking-tight whitespace-nowrap ${
              i % 2 ? "font-display font-extrabold text-ink" : "font-serif italic text-ink/70"}`}>{w}</span>
            <Sparkle className="h-6 w-6 sm:h-8 sm:w-8 text-terra shrink-0" />
          </span>
        ))}
      </div>
    </section>
  );
}
